import React, { useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import NewsContext from '../../context/news-context';

import Head from '../Head/index.js';
import SiteHeader from '../SiteHeader/index.js';
import { Main, Background, Container } from './style';

const Layout = ({ title, children }) => {
    const { user } = useContext(NewsContext);
    const history = useHistory();

    useEffect(()  => {
        if(Object.keys(user).length < 1){
            history.push('/');
        }
    }, []);

    return (
        <Background>  
            <Head title={title}>
            </Head>

            <Container>
                <SiteHeader />
                <Main>
                    { children }
                </Main>
            </Container>
        </ Background>
    )
};

export default Layout;